import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dual-select',
    templateUrl: './dualSelectMenu.component.html',
    styleUrls: ['./dualSelectMenu.component.scss']
})
export class dualSelectMenu {

    options = {
        label: 'name',
        itemKey: 'value'
    }

    constructor() { }
    @Input() mainList = [];
    mainSelectedList = [];
    @Output() mainListChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedList = [];
    selectedSelectedList = [];
    @Output() selectedListChange: EventEmitter<any> = new EventEmitter<any>();

    

    addToSelected(items: any[]) {
        items.forEach(i => {
            let index = this.mainList.findIndex(x => x == i);
            if (index < 0) {
                return
            }
            this.mainList.splice(index, 1);
            this.selectedList.push(i);
        })
    }

    removeFromSelected(items: any[]) {
        items.forEach(i => {
            let index = this.selectedList.findIndex(x => x == i);
            if (index < 0) {
                return
            }
            this.selectedList.splice(index, 1);
            this.mainList.push(i);
        })
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/dualSelectMenu/dualSelectMenu.component.ts